export interface ValidateShipmentRangeRequest {
  companyId: string;
  rcScopeId: string;
  materialId: string;
  shipmentId?: string;
  /** Inclusive lower bound for candidate filtering (`occurredAt >= rangeStartAt`). */
  rangeStartAt: string;
  /** Exclusive upper bound for candidate filtering (`occurredAt < rangeEndAt`). */
  rangeEndAt: string;
}

export const shipmentRangeValidationSeverityValues = ['none', 'warning', 'blocker'] as const;
export type ShipmentRangeValidationSeverity =
  (typeof shipmentRangeValidationSeverityValues)[number];

export const shipmentRangeValidationBlockingReasonValues = [
  'unsafe_overlap',
  'reported_boundary',
] as const;
export type ShipmentRangeValidationBlockingReason =
  (typeof shipmentRangeValidationBlockingReasonValues)[number];

export const shipmentRangeValidationWarningValues = ['historical_gap'] as const;
export type ShipmentRangeValidationWarning = (typeof shipmentRangeValidationWarningValues)[number];

export interface ShipmentRangeOverlap {
  hasOverlap: boolean;
  severity: Extract<ShipmentRangeValidationSeverity, 'none' | 'blocker'>;
  overlappedPurchaseCommittedIds: string[];
  reservedOverlapCount: number;
  departedOverlapCount: number;
  /** Recommended inclusive replacement for `rangeStartAt` when overlap is detected. */
  recommendedSafeStartAt: string | null;
}

export interface ShipmentRangeHistoricalGap {
  hasHistoricalGap: boolean;
  severity: Extract<ShipmentRangeValidationSeverity, 'none' | 'warning'>;
  earliestHistoricalUnshippedAt: string | null;
  /** Recommended replacement for `rangeStartAt` when the operator chooses to include the gap. */
  recommendedStartAt: string | null;
}

export interface ShipmentReportedBoundaryValidation {
  hasConflict: boolean;
  severity: Extract<ShipmentRangeValidationSeverity, 'none' | 'blocker'>;
  materialId: string;
  lastReportedEndAt: string | null;
  message: string | null;
}

export interface ValidateShipmentRangeResponse {
  isValid: boolean;
  canSubmit: boolean;
  overlap: ShipmentRangeOverlap;
  historicalGap: ShipmentRangeHistoricalGap;
  reportedBoundary: ShipmentReportedBoundaryValidation;
  blockingReasons: ShipmentRangeValidationBlockingReason[];
  warnings: ShipmentRangeValidationWarning[];
  notes?: string[];
}
